export function parseBoolean(bool) {
  if (bool === "1" || bool === "true" || bool === true) {
    return true;
  } else if (bool === "0" || bool === "false" || bool === false) {
    return false;
  } else {
    return null;
  }
}
